export enum EUdajeOFyzOsobach {
    NEUVEDENE = 'NEUV',
    UVEDENE = 'UV',
    NENI = 'NENI'
}
